import $ from 'cash-dom';
import ouibounce from 'ouibounce';
import xhr from '../components/http-request';
import Device from '../components/device';
import Popup from '../components/popup';
import CallboxLoader from '../components/callbox-loader';
import Cookie from 'js-cookie';
import PrequalState from '../parts/ppc/prequalify-modal/PrequalState';
import ShowQrCode from '../components/show-qr-code';
import Utils from '../components/Utils';
import UnclosablePopup from '../components/unclosable-popup';
import PopupScanCheck from './PopupScanCheck';
import PopupMobileButton from './PopupMobileButton';
import Countdown from './countdown';
import ExitPopupMobileTriggers from './ExitPopupMobileTriggers';
import ExitPopupEvents from './ExitPopupEvents';

const ExitPopup = {
	_mobilePopupShown: false,
	_popupHtml: null,
	_popupLoading: false,
	_popupInitialized: false,
	_ppcLanguage: null,
	_PopupScanCheck: null,
	_mobileButtonInstance: null,

	init() {
		this._ppcLanguage = this._ppcLanguage || $('html').attr('lang');

		if (Cookie.get('_exit_ppc_pp') !== undefined && window.location.hash !== '#force-exit-intent') {
			$('#show-popup-on-button').remove();
			return;
		}

		this._ensureMobileLauncher();

		if (PrequalState.getInstance().isPrequalShown) {
			$(document).on('PrequalifyModalHandler:prequalHide', () => {
				this.loadPopupHtml();
			});
		} else {
			this.loadPopupHtml();
		}
	},

	_isMobileExitContext() {
		return Device.isTrueMobile();
	},

	_ensureMobileLauncher() {
		const $button = $('#show-popup-on-button');
		if (!this._isMobileExitContext() || !$button.length) {
			return;
		}

		if (!this._mobileButtonInstance) {
			this._mobileButtonInstance = new PopupMobileButton({
				$button,
				onRequestContent: () => this.loadPopupHtml(true),
			});
			this._mobileButtonInstance.init();
		}
	},

	loadPopupHtml(reInitExitPopup) {
		if (Device.isGPSI()) {
			return;
		}

		const forceExitIntent = window.location.hash === '#force-exit-intent';
		const hasMobileLauncher = $('#show-popup-on-button').length > 0;
		const loadExitPopup = forceExitIntent
			|| Cookie.get('_exit_ppc_pp') === undefined
			|| hasMobileLauncher;

		if (loadExitPopup && !this._popupLoading) {
			this._popupLoading = true;

			this._PopupScanCheck = new PopupScanCheck();
			this._PopupScanCheck.init();

			const firstPpcVendor = $('.vendors-list .ppc-single-vendor:not(.hidden)').first();
			const vendorId = firstPpcVendor.length ? firstPpcVendor.attr('data-vendor-id') : 0;
			const productId = firstPpcVendor.length ? firstPpcVendor.attr('data-product-id') : 0;

			const secondPpcVendor = $('.vendors-list .ppc-single-vendor:not(.hidden)').eq(1);
			const secondVendorId = secondPpcVendor.length ? secondPpcVendor.attr('data-vendor-id') : 0;

			xhr.post(ajaxurl, {
				action: 'load-exit-intent',
				url: window.location.href,
				post_id: $('body').first().data('post-id'),
				is_mobile: Number(this._isMobileExitContext()),
				device: Device.resolveExitDevice(),
				fallback_vendor_id: vendorId,
				fallback_second_vendor_id: secondVendorId,
				product_id: productId,
				ppc_language: this._ppcLanguage,
			}, (error, html) => {
				this._popupLoading = false;

				if (error || !html || !html.trim()) {
					this._popupHtml = null;
					if (this._mobileButtonInstance) {
						this._mobileButtonInstance.hide();
					}
					return false;
				}

				this._popupHtml = html.trim();

				if (this._mobileButtonInstance) {
					this._mobileButtonInstance.setExitPopupHtml(this._popupHtml);
				}

				if (!this._popupInitialized || reInitExitPopup) {
					this._initExitPopup();
					this._popupInitialized = true;
				}
			});
		}
	},

	_initExitPopup() {
		const forceExitIntent = window.location.hash === '#force-exit-intent';
		const $exitPopup = $(this._popupHtml);

		if (!$exitPopup || !$exitPopup.length) {
			return false;
		}

		const popupVendorId = $exitPopup.find('.ppc-exit-popup').data('vendor-id');
		const setSelectQuoteSub_5 = document.body.classList.contains('set-sub5-for-us-life') && Utils.sub5Value !== null;
		const $vendor = this._getPpcVendorById(popupVendorId);
		const ppcVendorDeeplinkFamily = $vendor.length ? $vendor.data('deeplink-family') : undefined;

		if (setSelectQuoteSub_5) {
			// Hardcode for SelectQuote vendor on US Life
			Utils.addHardcodedSubIdToLinks(Utils.sub5Value, 769, $exitPopup);
		}
		if (ppcVendorDeeplinkFamily) {
			Utils.setFilteredDeeplinkFamilyForAllLinksOfVendor(ppcVendorDeeplinkFamily, popupVendorId, $exitPopup);
		}

		if (ppcVendorDeeplinkFamily || setSelectQuoteSub_5) {
			this._popupHtml = $exitPopup.get().map((node) => node.outerHTML || node.nodeValue || '').join('');
		}

		if (this._isMobileExitContext()) {
			const isSafetyCheck = this._isSafetyCheckTemplate($exitPopup);
			const isVpnmentor = this._isVpnmentorBanner($exitPopup);
			const isWizcase = this._isWizcaseBanner($exitPopup);

			if (isVpnmentor || isWizcase) {
				$('#show-popup-on-button').addClass('hidden');
				if (this._mobileButtonInstance) {
					this._mobileButtonInstance.hide();
				}
				this._showVpnmentorMobilePopup(forceExitIntent);
			} else if ($('#show-popup-on-button').length && isSafetyCheck) {
				if (!this._mobileButtonInstance) {
					this._showPopupOnButton();
				} else {
					this._mobileButtonInstance.setExitPopupHtml(this._popupHtml);
				}
			} else {
				$('#show-popup-on-button').addClass('hidden');
				if (this._mobileButtonInstance) {
					this._mobileButtonInstance.hide();
				}
				this._showRegularMobilePopup(forceExitIntent);
			}
		} else {
			if (forceExitIntent) {
				this._showDesktopPopup();
			} else {
				ouibounce($exitPopup.get(0), {
					aggressive: forceExitIntent,
					sitewide: true,
					cookieDomain: `.${window.location.host}`,
					timer: 150,
					delay: 30,
					cookieExpire: 30,
					cookieName: forceExitIntent ? null : '_exit_ppc_pp',
					callback: () => {
						this._showDesktopPopup();
					}
				});
			}
		}
	},

	_getPpcVendorById(vendorId) {
		return $(`.vendors-list .ppc-single-vendor[data-vendor-id="${vendorId}"]`);
	},

	_isSafetyCheckTemplate($exitPopup) {
		const selector = '.safety-check, [data-class-name*="safety-check"]';
		return $exitPopup.is(selector) || $exitPopup.find(selector).length > 0;
	},

	_isVpnmentorBanner($exitPopup) {
		const selector = '.vpnmentor-exit-intent, [data-class-name*="vpnmentor-exit-intent"]';
		return $exitPopup.is(selector) || $exitPopup.find(selector).length > 0;
	},

	_isWizcaseBanner($exitPopup) {
		const selector = '.wizcase-exit-intent, [data-class-name*="wizcase-exit-intent"]';
		return $exitPopup.is(selector) || $exitPopup.find(selector).length > 0;
	},

	_showPopupOnButton() {
		const $exitPopup = $(this._popupHtml);

		if (!$exitPopup.length) {
			return;
		}

		if (!this._mobileButtonInstance) {
			this._mobileButtonInstance = new PopupMobileButton({
				$button: $('#show-popup-on-button'),
				$exitPopup,
				onRequestContent: () => this.loadPopupHtml(true),
			});
			this._mobileButtonInstance.init();
		} else {
			this._mobileButtonInstance.setExitPopupHtml(this._popupHtml);
		}
	},

	_showVpnmentorMobilePopup(forceExitIntent) {
		ExitPopupMobileTriggers.showVpnmentorMobilePopup({
			isShown: () => this._mobilePopupShown,
			showPopup: (triggerType) => this._showMobilePopup(triggerType),
		}, forceExitIntent);
	},

	_showRegularMobilePopup(forceExitIntent) {
		ExitPopupMobileTriggers.showRegularMobilePopup({
			isShown: () => this._mobilePopupShown,
			showPopup: (triggerType) => this._showMobilePopup(triggerType),
		}, forceExitIntent);
	},

	_displayPopup(isMobile = false, triggerType = null) {
		const $exitPopup = $(this._popupHtml);
		if (!$exitPopup.length) {
			return false;
		}

		const $exitPopupContainer = $exitPopup.find('.ppc-exit-popup');
		const showCloseBtn = $exitPopupContainer.attr('data-show-close-btn');
		const className = $exitPopupContainer.attr('data-class-name');

		if (CallboxLoader.hasPhones($exitPopup)) {
			CallboxLoader.appendScript();
		}

		if (isMobile) {
			this._mobilePopupShown = true;
			Cookie.set('_exit_ppc_pp', true);
		}

		const popup = showCloseBtn === '1'
			? new Popup({ containerClass: 'exit-intent-popup' })
			: new UnclosablePopup({ containerClass: 'exit-intent-popup' });

		const popupClass = `exit-popup${className ? ` ${className}` : ''}`;
		const $cloned = $exitPopup.children().clone();
		if (isMobile) {
			$cloned.attr('data-btn-name', 'Exit Intent - Mobile Popup Overlay');
			$cloned.attr('data-ga-label', 'Exit Intent - Mobile Popup Overlay');
		}
		popup.show($cloned, popupClass);

		Countdown.init();

		this.sendExitPopupEvents($exitPopup, isMobile, triggerType);

		const $content = $('#fm-popup .popup-content');

		$content.find('.main-cta, .overlay-link').on('click', () => {
			popup.hide();
		});

		$content.find('.ppc-icon-close, .popup-close').on('click', (e) => {
			e.preventDefault();
			popup.hide();
		});

		$content.find('[data-href]').on('click', (e) => {
			if ($(e.target).hasClass('unbind-data-href') || $(e.target).closest('.unbind-data-href').length) {
				return;
			}
			if ($content.find('.vpnmentor-exit-intent, .wizcase-exit-intent').length > 0) {
				popup.hide();
			}
		});

		$content.find('#run-check').on('click', (e) => {
			e.preventDefault();
			this._PopupScanCheck.scan($content.find('.safety-check'));
		});

		if ($('.ppc-exit-popup').hasClass('popup-with-qr')) {
			ShowQrCode.init();
		}

		$('.fm-popup.exit-popup').removeClass('ppc-prequal-popup');
		return true;
	},

	_showDesktopPopup() {
		return this._displayPopup(false);
	},

	_showMobilePopup(triggerType) {
		return this._displayPopup(true, triggerType);
	},

	sendExitPopupEvents(popup, isMobile, triggerType) {
		ExitPopupEvents.sendEvents(popup, isMobile, triggerType);
	},
};

export default ExitPopup;
